// AT-1487: het deelblok "Neem iemand mee" op de Orange2-bevestigingspagina
// (transactions/orange2/_share). De losse knoppen staan er zonder JavaScript al. Op een
// telefoon met een deelmenu (navigator.share) komt er één knop voor in de plaats. Weigert de
// browser dat menu, bijvoorbeeld in een iframe zonder allow="web-share", dan komen de losse
// knoppen terug. Desktops laten we op de losse knoppen: het deelmenu van Windows en macOS is
// voor een link naar een evenement eerder in de weg dan handig.

function nativeShareAvailable(data) {
  if (typeof navigator.share !== 'function') return false
  if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) return false
  return typeof navigator.canShare !== 'function' || navigator.canShare(data)
}

// navigator.clipboard mag in een iframe alleen met allow="clipboard-write"; daarbuiten
// werkt de oude route via een tijdelijk tekstveld nog.
function copyText(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text).catch(() => copyWithTextarea(text))
  }
  return copyWithTextarea(text)
}

function copyWithTextarea(text) {
  return new Promise((resolve, reject) => {
    const field = document.createElement('textarea')
    field.value = text
    field.setAttribute('readonly', '')
    field.style.position = 'fixed'
    field.style.opacity = '0'
    document.body.appendChild(field)
    field.select()
    const ok = document.execCommand && document.execCommand('copy')
    document.body.removeChild(field)
    ok ? resolve() : reject(new Error('copy failed'))
  })
}

function initSharePanel(panel) {
  const data = {
    title: panel.dataset.shareTitle,
    text: panel.dataset.shareText,
    url: panel.dataset.shareUrl
  }
  const nativeButton = panel.querySelector('[data-share-native]')
  const options = panel.querySelector('[data-share-options]')

  if (nativeButton && options && nativeShareAvailable(data)) {
    nativeButton.hidden = false
    options.hidden = true
    nativeButton.addEventListener('click', () => {
      navigator.share(data).catch((error) => {
        // De koper sloot het menu zelf; dan hoeft er niets te veranderen.
        if (error && error.name === 'AbortError') return
        nativeButton.hidden = true
        options.hidden = false
      })
    })
  }

  const copyButton = panel.querySelector('[data-share-copy]')
  if (!copyButton) return
  const label = copyButton.querySelector('[data-share-copy-label]')
  const original = label.textContent
  copyButton.addEventListener('click', () => {
    copyText(data.url).then(() => {
      label.textContent = copyButton.dataset.copiedLabel
      copyButton.classList.add('is-copied')
      setTimeout(() => {
        label.textContent = original
        copyButton.classList.remove('is-copied')
      }, 2000)
    }).catch(() => window.prompt && window.prompt('', data.url))
  })
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-share-panel]').forEach(initSharePanel)
})
